export default __webpack_public_path__ + "static/media/GTWalsheimPro-Regular.1fd3cd7a.ttf";